import { gql } from '@apollo/client'

export const VehicleNodeFragment = gql`
  fragment vehicleNode on VehicleNode {
    id
    registrationNumber
    milage
  }
`
